<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 ">
        <body>
            <div class="layout-wrapper layout-content-navbar layout-without-menu">
                <div class="layout-container">
                    <div class="layout-page">
                        <nav class="navbar navbar-expand-lg menu-header navbar-light ">
                            <div class="container pe-lg-2 p-0 ">
                                <a class="navbar-brand fw-bold fs-3" href="#">
                                    <img src="../../../assets/images/final automated.png" style="width:160px">
                                </a>
                                <button mat-button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                    aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                    <!-- <ul class="navbar-nav mr-auto ms-auto mb-2 mb-lg-0">
                                        <li class="nav-item">
                                            <a class="nav-link pe-3 me-4 active" aria-current="page" href="#">Home</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link pe-3 me-4 " href="#">Services</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link pe-3 me-4 " href="#">Contact</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link pe-3 me-4 " href="#">About Us</a>
                                        </li>
                                    </ul> -->
                                    <ul class="navbar-nav icons ms-auto mb-2 mb-lg-0">
                                        <li class="nav-item">
                                            <!-- <a [routerLink]="['/signin']">
                                                <button mat-button type="button" class="btn btn-primary "
                                                    style="background-color: #117fdf;;color:#fff;margin-left: 5px;">
                                                    Sign
                                                    In
                                                </button></a> -->
                                            <a [routerLink]="['/signin']">
                                                <button mat-button type="button" class="btn btn-primary "
                                                    style="background-color: #b7ce83;color:hwb(239 4% 54%);margin-left: 5px;">
                                                    Sign
                                                    In
                                                </button></a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="/#/registration">
                                                <button mat-button type="button" id=""
                                                    class="btn btn-outline me-2 register">Sign Up</button>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>

                        <div class="main-banner" id="top">
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="caption header-text">
                                            <h6>Automated Fee Services</h6>
                                            <div class="line-dec"></div>
                                            <h4>Best <em>Payment</em> Services <span></span></h4>
                                            <p>
                                                Automated fee services are designed to be integrated with an online
                                                payment gateway, allowing clients to make payments conveniently through
                                                a website or mobile app.
                                                Clients can access the payment portal and initiate transactions
                                                securely, eliminating the need for physical checks or cash payments.
                                            </p>

                                            <!-- <div class="buttonRow">
                                                <button class="main-button scroll-to-section">
                                                    <a href="" type="button" style="color: #fff !important;">
                                                        Discover More</a>
                                                </button>
                                                <button class="second-button">
                                                    <a href="#" type=" btn btn-primary">Connect With Us</a>
                                                </button>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <img src="../../../assets/images/payQR.png" class="payImage">
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-lg-6">
                                        <div class="caption header-text">
                                            <h6>Appraisal Services</h6>
                                            <div class="line-dec"></div>
                                            <h4>Best <em>Payment</em> Services <span></span></h4>
                                            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis,
                                                itaque
                                                ullam voluptatem nam neque rerum dolorem sunt quo labore porro fuga
                                                accusamus id optio soluta facere unde aliquam. Molestias, sunt.</p>

                                            <div class="buttonRow">
                                                <button class="main-button scroll-to-section">
                                                    <a href="" type="button" style="color: #fff !important;">
                                                        Discover More</a>
                                                </button>
                                                <button class="second-button">
                                                    <a href="#" type=" btn btn-primary">Connect With Us</a>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <img src="../../../assets/images/paybanner-imagesdc.png">
                                    </div>
                                </div> -->
                            </div>
                        </div>

                        <div class="services section" id="services">
                            <div class="container">
                                <div class="row contianer-2">
                                    <!-- <div class="col-lg-5 gateway">
                                        <img src="../../../assets/images/Payment-GATEWAY-Integrations.png" width="100%">
                                    </div> -->
                                    <div class="col-lg-12 ">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="service-class"></div>
                                                <div class="section-heading">
                                                    <h2>We Provide <em>Different Services</em> &amp;
                                                        <span>Features</span> For Your Needs
                                                    </h2>
                                                    <div class="line-dec-1">
                                                    </div>
                                                    <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed doers eiusmod.</p> -->
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-3">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-01.jpg"
                                                                alt="discover SEO" class="templatemo-feature">
                                                        </div>
                                                        <h4>Optimizing Service</h4>
                                                        Optimizing the borrower's front-end experience enabled more
                                                        mortgage originations without the burden of financing,
                                                        accounting and payment processing.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-2">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-04.jpg"
                                                                alt="SEO marketing" class="templatemo-feature">
                                                        </div>
                                                        <h4>Customized Customer Report</h4>
                                                        Seamless integration of the platform into customer’s loan
                                                        origination system, enabling focus on providing customized
                                                        customer experiences
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-1">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-03.jpg"
                                                                alt="precise data" class="templatemo-feature">
                                                        </div>
                                                        <!-- <h4>Global Support</h4>
                                                        Global support
                                                        teams established
                                                        to handle daily
                                                        payment
                                                        processing and
                                                        client inquiries
                                                        such as payment
                                                        processing,
                                                        refunds, and
                                                        disputes -->
                                                        <h4>Real-time Transaction Tracking</h4>
                                                        Transparent, real-time transaction tracking is available for
                                                        both borrowers and lenders, offering complete visibility into
                                                        the payment process.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-2">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-02.jpg"
                                                                alt="data analysis" class="templatemo-feature">
                                                        </div>
                                                        <h4>API Integration</h4>
                                                        AFS offers seamless integration through APIs, allowing lenders
                                                        to effortlessly incorporate our solution into their existing
                                                        systems for a frictionless experience.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-3">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-01.jpg"
                                                                alt="discover SEO" class="templatemo-feature">
                                                        </div>
                                                        <h4>PCI Compliance</h4>
                                                        We prioritize the highest level of data security by maintaining
                                                        PCI compliance standards, ensuring that all payment information
                                                        is safeguarded against potential breaches.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-3">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-04.jpg"
                                                                alt="SEO marketing" class="templatemo-feature">
                                                        </div>
                                                        <h4>Automated Fee Requests</h4>
                                                        Our platform automates the appraisal fee request process,
                                                        reducing manual efforts and minimizing the risk of errors.
                                                        Lenders can initiate fee requests effortlessly.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-3">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-03.jpg"
                                                                alt="precise data" class="templatemo-feature">
                                                        </div>
                                                        <h4>Secure Payment Processing</h4>
                                                        AFS provides a secure and reliable payment processing system,
                                                        giving borrowers peace of mind when making appraisal fee
                                                        payments.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item ">
                                                        <div class="icon">
                                                            <img src="../../../assets/images/services-02.jpg"
                                                                alt="data analysis" class="templatemo-feature">
                                                        </div>
                                                        <h4>Advanced Fraud Detection</h4>
                                                        AFS incorporates state-of-the-art fraud detection algorithms and
                                                        mechanisms to protect lenders and borrowers from fraudulent
                                                        activities, providing an extra layer of security.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="services1 section mb-5" id="services1">
                            <div class="container">
                                <div class="row contianer-2">
                                    <!-- <div class="col-lg-5 gateway">
                                        <img src="../../../assets/images/Payment-GATEWAY-Integrations.png" width="100%">
                                    </div> -->
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="service-class"></div>
                                                <div class="section-heading mb-5">
                                                    <h2>Benefits</h2>
                                                    <div class="line-dec-1">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3 active">
                                                <div class="card">
                                                    <div class="service-item">
                                                        <!-- <div class="icon">
                                                            <img src="../../../assets/images/services-01.jpg"
                                                                alt="discover SEO" class="templatemo-feature">
                                                        </div> -->
                                                        <h4>Convenient Payment Processing</h4>
                                                        <div class="line-dec4">
                                                        </div>
                                                        Borrowers can securely make payments from anywhere, simplifying
                                                        the mortgage experience.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-4">
                                                        <!-- <div class="icon">
                                                            <img src="../../../assets/images/services-04.jpg"
                                                                alt="SEO marketing" class="templatemo-feature">
                                                        </div> -->
                                                        <h4>Efficiency and Integration</h4>
                                                        <div class="line-dec4">
                                                        </div>
                                                        AFS seamlessly integrates into existing systems, optimizing
                                                        efficiency for lenders.

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item">
                                                        <!-- <div class="icon">
                                                            <img src="../../../assets/images/services-03.jpg"
                                                                alt="precise data" class="templatemo-feature">
                                                        </div> -->
                                                        <h4><br>Data Security</h4>
                                                        <div class="line-dec4">
                                                        </div>
                                                        PCI compliance guarantees top-tier data security, while advanced
                                                        fraud detection adds an extra layer of protection.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-sm-3">
                                                <div class="card">
                                                    <div class="service-item mb-4">
                                                        <!-- <div class="icon">
                                                            <img src="../../../assets/images/services-02.jpg"
                                                                alt="data analysis" class="templatemo-feature">
                                                        </div> -->
                                                        <h4><br>Regulatory Confidence</h4>
                                                        <div class="line-dec4">
                                                        </div>
                                                        Lenders can confidently meet industry regulations and reporting
                                                        requirements with AFS.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <!-- footer -->
                    <footer class="footer">
                        <div class="row footerContent first">
                            <div class="col-md-5">
                                <ul>
                                    <!-- <li style="color: rgb(10, 32, 97);"><b>Automated Fee Services :</b><br></li> -->
                                    Automated Fee Services (AFS) is a cutting-edge mortgage payment service lender that
                                    goes beyond the ordinary. Our platform is API-enabled, PCI compliant, and equipped
                                    with advanced fraud detection capabilities, setting a new standard in the mortgage
                                    industry. AFS is meticulously designed to streamline and simplify the process of
                                    managing appraisal fees for both lenders and borrowers while ensuring the highest
                                    levels of security and efficiency.

                                </ul>
                            </div>
                            <div class="col-md-4">

                            </div>

                            <div class="col-md-3">
                                <ul class="contact vertical">
                                    <li><b>Contact Us- </b><br></li>
                                    <b>A</b>: 800 E Campbell Road,
                                    Suite 288 Richardson,
                                    Dallas, Texas - 75081<br>
                                    <b>M:</b> (877)997-8682<br>
                                    <b>E:</b> afsopssupport@infovision.com

                                    <!-- <li class="nav-item">Help & FAQ</li> -->
                                </ul>
                            </div>
                        </div>
                        <!-- <hr> -->
                        <div class="text-center">
                            © {{ currentYear }} - Powered by <a href="https://www.infovision.com/"><img
                                    src="../../../assets/images/InfoVision_logo.png" alt="Logo" class="login-logo"></a>
                        </div>
                    </footer>
                </div>
            </div>
        </body>
    </div>
</div>